import React from 'react';
import { useMediaQuery } from 'react-responsive';
import TrackVisibility from 'react-on-screen';
import classnames from 'classnames';
import { I18n, translate } from '@fiverr-private/i18n-react';
import CardSellerProfile from '@fiverr-private/variations_display/src/components/cards/CardSellerProfile';
import { GET_INSPIRED_CONTENT, INNER_CLASSES } from '../constants';
import './style.scss';

export const calculateSmallSizeLength = (total) => {
    const smallSizeMultiple = 3; // in the small size, we only want to show items in multiples of 3

    return Math.floor(total / smallSizeMultiple) / (1 / smallSizeMultiple);
};

const GetInspired = () => {
    const isSmallSize = useMediaQuery({
        query: '(min-width: 600px) and (max-width: 899px)',
    });

    const sections = GET_INSPIRED_CONTENT;
    const sectionsLength = sections.length;

    return (
        <div className={classnames('get-inspired', INNER_CLASSES)}>
            <h2 className="text-display-2">
                <I18n k="makers_experience_perseus.buyer_landing_page.get_inspired.section_title" />
            </h2>
            <div className="logo-grid grid-15">
                {sections
                    .slice(
                        0,
                        isSmallSize
                            ? calculateSmallSizeLength(sectionsLength)
                            : sectionsLength
                    )
                    .map((section) => (
                        <TrackVisibility
                            offset={200}
                            once
                            partialVisibility
                            tag="div"
                            className="col-5-xs col-3-md"
                            key={section.id}
                        >
                            {({ isVisible }) => (
                                <div className="inspired-card">
                                    {isVisible && (
                                        <img
                                            src={section.image}
                                            alt={translate(
                                                `makers_experience_perseus.buyer_landing_page.get_inspired.item_${section.id}.alt`
                                            )}
                                        />
                                    )}
                                    <CardSellerProfile
                                        username={section.designer}
                                        thumbnail={section.designerProfileImage}
                                        size={24}
                                    />
                                </div>
                            )}
                        </TrackVisibility>
                    ))}
            </div>
        </div>
    );
};

export default GetInspired;
